;
import { generateComponentUUID } from "../utils/uuid"
import { Vue, Component } from 'vue-facing-decorator';

@Component
export default class ComponentID extends Vue {
  componentID: string = ''

  created() {
    this.componentID = generateComponentUUID();
  }
}
